module.exports = new __parcel__URL__("logo.bdb3b38f.png").toString();